import { render } from "./OptionGroup.vue?vue&type=template&id=72b2afe8&scoped=true"
import script from "./OptionGroup.vue?vue&type=script&lang=js"
export * from "./OptionGroup.vue?vue&type=script&lang=js"

import "./OptionGroup.vue?vue&type=style&index=0&id=72b2afe8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b2afe8"]])

export default __exports__